import {
    ACTION_GET_CARDS,
    ACTION_GET_TABLE,
    ACTION_POST_SEND,
    SET_CARDS,
    SET_TABLE,
    SET_PAYMENTMETHON_LIST,
    ACTION_POST_PAYMENT_SUPPORT,
    ACTION_GET_PAYMENTMETHON_LIST,
    ACTION_POST_CHANGE_STATE_START,
    ACTION_POST_CONFIRM_RESERVATION,
    ACTION_POST_CODE_CONFIRMATION_RESERVATION,
    ACTION_POST_RESEND_CODE_CONFIRMATION_RESERVATION
} from "@/views/recognition/store/types/types.js";

import axios from '@/plugins/http/axios.js';
import config from "@/views/recognition/config/recognition.js";
import PathUri from '@/utils/path_uri';
import EventBus from '@/utils/event_bus.js';
import { recognitionService } from "../../../services";
import i18n from '@/plugins/i18n';

const _pathUri = new PathUri(config.port, config.context);

const actions = {

    [ACTION_GET_CARDS]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {

                state.loadingValidationEmail = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");
                recognitionService.getCards(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_CARDS, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loadingValidationEmail = false;
                    });

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_TABLE]: ({ state, commit }) => {

        return new Promise((resolve, reject) => {
            try {
                state.loadingValidationEmail = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const userId = sessionStorage.getItem("idUsuario");
                const companyId = sessionStorage.getItem("idEmpresa");

                recognitionService.getTable(idGroup, companyId, userId)
                    .then(async resp => {
                        commit(SET_TABLE, resp.data.payload);
                        resolve(resp);
                    })
                    .catch(error => {
                        reject(error);
                    })
                    .finally(() => {
                        state.loadingValidationEmail = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_SEND]: ({ state }, payload) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingAffiliated = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                recognitionService.postSend({ idGroup, idEmpresa, idUsuario, payload })
                    .then(async response => {
                        EventBus.$emit('modal-payload', response.data.payload);
                        resolve(response.data.payload);
                    })
                    .finally(() => {
                        state.loadingAffiliated = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_GET_PAYMENTMETHON_LIST]: async ({ state, commit }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingUser = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                recognitionService.getPaymentMethon(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload && Array.isArray(resp.data.payload)) {
                            const typePaymentMethon = resp.data.payload.map((e, i) => ({
                                ...e,
                                activeDialogClient: false,
                                index: i
                            }));
                            commit(SET_PAYMENTMETHON_LIST, typePaymentMethon);
                            resolve(resp.data.payload);

                        } else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingUser = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_PAYMENT_SUPPORT]: ({ state }, transactionId) => {

        const formdata = new FormData();
        formdata.append("transactionId", transactionId);
       
        return new Promise((resolve, reject) => {

            try {
                state.loading = true;
                axios({
                    method: 'post',
                    url: `${config.baseUrl + _pathUri.generateUri() + sessionStorage.getItem("idGroup")}/transaction/confirm-otp`,
                    headers: {
                        'idEmpresa': sessionStorage.getItem("idEmpresa"),
                        'idUsuario': sessionStorage.getItem("idUsuario")
                    },
                    data: formdata,
                    redirect: 'follow'
                })
                    .then(async (resp) => {
                        if (resp && resp.status === 200) {
                            resolve(resp);
                        } else {
                            reject(i18n.t('label.actionReject'));
                        }
                    })
                    .catch(err => {
                        reject(err);
                    })
                    .finally(() => state.loading = false);

            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },


    [ACTION_POST_CODE_CONFIRMATION_RESERVATION]: async ({ state }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingCode = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                recognitionService.tokenConfirmationReservation(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload) {
                            resolve(resp.data.payload);
                        }else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingCode = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CONFIRM_RESERVATION]: async ({ state }, code) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingCode = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                recognitionService.confirmReservation(idGroup, idEmpresa, idUsuario, code)
                    .then(resp => {
                        if (resp.data.payload) {
                            resolve(resp.data.payload);
                        }else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingCode = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_RESEND_CODE_CONFIRMATION_RESERVATION]: async ({ state }) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingCode = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                recognitionService.tokenConfirmationReservation(idGroup, idEmpresa, idUsuario)
                    .then(resp => {
                        if (resp.data.payload) {
                            resolve(resp.data.payload);
                        }else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingCode = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },

    [ACTION_POST_CHANGE_STATE_START]: async ({ state }, data) => {
        return new Promise((resolve, reject) => {
            try {
                state.loadingCode = true;

                const idGroup = sessionStorage.getItem("idGroup");
                const idEmpresa = sessionStorage.getItem("idEmpresa");
                const idUsuario = sessionStorage.getItem("idUsuario");

                recognitionService.postChangeStateStart(idGroup, idEmpresa, idUsuario, data)
                    .then(resp => {
                        if (resp.data.payload) {
                            resolve(resp.data.payload);
                        }else {
                            console.error(i18n.t('label.actionRejectError'), resp);
                            reject(i18n.t('label.actionRejectError'));
                        }
                    })
                    .catch(err => {
                        console.error(i18n.t('label.actionErrorRequest'), err);
                        reject(err);
                    })
                    .finally(() => {
                        state.loadingCode = false;
                    });
            } catch (error) {
                console.error(i18n.t('label.actionErrorRequest'), error);
                reject(error);
            }
        });
    },
}

export default actions